export default __webpack_public_path__ + "static/education-training-menu-img-169c90767eb9fb54c649fd2cd37143a4.jpg";